import React from "react";
import './Featured.css'
const Featured =(props) =>{
    return(
        <div id="Browse bikes by">
            <h4 class="text-center mt-4 text1"  >Featured bikes</h4>
            <div class=" Container">
                <div class="w-75  col1">
                    <div class="card text-center">
                        <div class="card-header">
                            <ul class="nav nav-tabs  card-header-tabs">
                            <li class="nav-item feliw">
                                <a class="nav-link active" aria-current="true" href="#">Most Popular</a>
                            </li>
                            <li class="nav-item feliw">
                                <a class="nav-link disabled" href="#">New launches</a>
                            </li>
                            <li class="nav-item feliw">
                                <a class="nav-link disabled" href="#" tabindex="-1" aria-disabled="true">Upcoming</a>
                            </li>
                            </ul>
                        </div>
                        <div class="card-body">
                            <div class="card-group p-1">
                                <div class="card m-2">
                                    <img src="https://mohit6795.github.io/Bikewale-Bootstrap/feature%20or%20best%20bikes%20img/g310-rr-right-front-three-quarter.webp" class="card-img-top" alt="..."/>
                                    <div class="card-body">
                                        <h5 class="bikename">BMW G310 RR</h5>
                                        <p class="shortspecification">312 cc, 33.5 bhp, 174 kg</p>
                                        <div>
                                            <span class="pricetitle">Avg. Ex-showroom price</span>
                                            <span class="onlineprice">₹ 2,85,000</span>
                                        </div>
                                        <span class="font14">onwards</span> 
                                        <div>
                                            <button class="pricebtn">Check on-road price</button>
                                        </div>
                                    </div>
                                </div>

                                <div class="card m-2">
                                    <img src="https://mohit6795.github.io/Bikewale-Bootstrap/feature%20or%20best%20bikes%20img/ronin-225-right-front-three-quarter.webp" class="card-img-top" alt="..."/>
                                    <div class="card-body">
                                        <h5 class="bikename">TVS Ronin 225</h5>
                                        <p class="shortspecification">226 cc, 20 bhp, 159kg</p>
                                        <span class="pricetitle">Avg. Ex-showroom price</span>
                                        <div>
                                            <span class="onlineprice">₹ 1,49,000</span>
                                            <span class="font14">onwards</span>
                                        </div> 
                                        <div>
                                            <button class="pricebtn">Check on-road price</button>
                                        </div>                                
                                    </div>
                                </div>

                                <div class="card m-2">
                                    <img src="https://mohit6795.github.io/Bikewale-Bootstrap/feature%20or%20best%20bikes%20img/R15%20V4%20Model%20Image.jpg" class="card-img-top" alt="..."/>
                                    <div class="card-body">
                                        <h5 class="bikename ">R15 V4</h5>
                                        <p class="shortspecification">155cc, 18.1bhp, 142kg</p>
                                        <span class="pricetitle">Avg. Ex-showroom price</span>
                                        <div>
                                            <span class="onlineprice">₹ 1,78,000</span>
                                            <span class="font14">onwards</span>
                                        </div>                             
                                        <div>
                                            <button class="pricebtn">Check on-road price</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="d-grid gap-2 col-3 mx-auto w-50">
                            <a href="listpage.html"><button type="button" class="btn btn-outline-warning mb-2 view-all-target-btn ">View more Brands</button></a>
                        </div> 
                    </div>
                </div>
            </div>
        </div>
    )
}
export default Featured;